import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentAdministrationComponent } from './component/supplementary-equipment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryFieldsModule, MasterDetailModule,  TableSelectionDialogModule } from '@sdbn/common';

import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { EquipmentIdentifierComponent } from './component/equipment-identifier/equipment-identifier.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    SupplementaryEquipmentAdministrationComponent,
    EquipmentIdentifierComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TableSelectionDialogModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    TransportOptionsPanelModule,
    DictionaryModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule
  ],

})
export class SupplementaryEquipmentAdministrationModule { }
